import { API_CALL } from 'actions/actionConstants'
import { FETCH_TOUR_BUNDLE } from 'actions/apiActionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { getBundle } from 'api/bundle'
import config from 'constants/config'

const BUNDLED_TOUR_ID = 'tour-e8c5e5c1-7eae-430d-91e4-aeb9a670258c'
const BUNDLE_ID = 'eec100f7-c3f5-4350-829f-61d1b4675ddf'

export default function fetchTourBundle(tourId: string): AppAction {
  return (dispatch, getState) => {
    if (config.APP_ENV === 'production' || tourId !== BUNDLED_TOUR_ID) return

    const current = getState().tour.bundlesByTourId[tourId]
    if (current?.data || current?.fetching) return

    dispatch({
      type: API_CALL,
      api: FETCH_TOUR_BUNDLE,
      request: () => getBundle(BUNDLE_ID),
      tourId,
      currencyCode: getState().geo.currentCurrency,
    })
  }
}
